module["exports"] = [
  "+91###-###-####",
  "+91##########",
  "+91-###-#######"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en_IND/phone_number/formats.js
// module id = 700
// module chunks = 0